import React from 'react';
import { CONTENT_BASE } from '@amzn/ring-common-style-library/lib/colors';
import { translated } from '../../utils/TranslationUtil';

export const ReceiptIcon: React.FC = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 24 24' fill='none'>
            <title>{translated('Accessibility.SvgTitle.receiptIcon')}</title>
            <g id='check (e90b)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M21.0902 5.7095L9.09022 17.7095L3.41022 12.0795C3.31922 11.9885 3.19422 11.9325 3.05522 11.9325C2.77822 11.9325 2.55322 12.1575 2.55322 12.4345C2.55322 12.5735 2.60922 12.6985 2.70022 12.7895L9.06022 19.1495L21.8002 6.4195C21.8912 6.3285 21.9472 6.2035 21.9472 6.0645C21.9472 5.7875 21.7222 5.5625 21.4452 5.5625C21.3062 5.5625 21.1812 5.6185 21.0902 5.7095Z'
                    fill={CONTENT_BASE}
                />
            </g>
        </svg>
    );
};